import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import Layout from "@/components/Layout";
import Analytics from "@/components/Analytics";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Compare from "@/pages/Compare";
import Upgrade from "@/pages/Upgrade";
import BookTrial from "@/pages/BookTrial";
import ClinicsPage from "@/pages/ClinicsPage";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import SeoPage from "@/pages/SeoPage";
import LocalePage from "@/pages/LocalePage";
import LocationsIndex from "@/pages/LocationsIndex";
import LearnHub from "@/pages/LearnHub";
import LearnArticle from "@/pages/LearnArticle";
import CompareLanding from "@/pages/CompareLanding";
import HearingTest from "@/pages/HearingTest";
import ProductFinder from "@/pages/ProductFinder";
import SupportCentre from "@/pages/SupportCentre";
import PolicyPage from "@/pages/PolicyPage";
import ClinicDetail from "@/pages/ClinicDetail";
import LearnPath from "@/pages/LearnPath";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ProtectedAdmin from "@/components/ProtectedAdmin";

function App() {
    return (
        <div className="App">
            <HelmetProvider>
                <AuthProvider>
                    <CartProvider>
                        <BrowserRouter>
                            <Analytics />
                            <Toaster position="top-center" richColors />
                            <Routes>
                                <Route element={<Layout />}>
                                    <Route path="/" element={<Home />} />
                                    <Route path="/products" element={<Products />} />
                                    <Route path="/products/:slug" element={<ProductDetail />} />
                                    <Route path="/compare" element={<Compare />} />
                                    <Route path="/upgrade" element={<Upgrade />} />
                                    <Route path="/book-trial" element={<BookTrial />} />
                                    <Route path="/clinics" element={<ClinicsPage />} />
                                    <Route path="/cart" element={<Cart />} />
                                    <Route path="/checkout" element={<Checkout />} />
                                    <Route path="/order-success/:orderNumber" element={<OrderSuccess />} />
                                    <Route path="/seo/:slug" element={<SeoPage />} />
                                    <Route path="/hearing-aids" element={<LocationsIndex />} />
                                    <Route path="/hearing-aids/:loc" element={<LocalePage />} />
                                    <Route path="/hearing-aids/:loc/:prod" element={<LocalePage />} />
                                    <Route path="/learn" element={<LearnHub />} />
                                    <Route path="/learn/paths/:slug" element={<LearnPath />} />
                                    <Route path="/learn/:slug" element={<LearnArticle />} />
                                    <Route path="/compare/:slug" element={<CompareLanding />} />
                                    <Route path="/hearing-test" element={<HearingTest />} />
                                    <Route path="/find" element={<ProductFinder />} />
                                    <Route path="/support" element={<SupportCentre />} />
                                    <Route path="/about" element={<PolicyPage />} />
                                    <Route path="/policies/:slug" element={<PolicyPage />} />
                                    <Route path="/clinics/:slug" element={<ClinicDetail />} />
                                </Route>
                                <Route path="/admin/login" element={<AdminLogin />} />
                                <Route
                                    path="/admin"
                                    element={
                                        <ProtectedAdmin>
                                            <AdminDashboard />
                                        </ProtectedAdmin>
                                    }
                                />
                            </Routes>
                        </BrowserRouter>
                    </CartProvider>
                </AuthProvider>
            </HelmetProvider>
        </div>
    );
}

export default App;
